import { render } from "./TrustedBy.vue?vue&type=template&id=6a722cae&scoped=true"
import script from "./TrustedBy.vue?vue&type=script&setup=true&lang=js"
export * from "./TrustedBy.vue?vue&type=script&setup=true&lang=js"

import "./TrustedBy.vue?vue&type=style&index=0&id=6a722cae&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a722cae"],['__file',"src/components/TrustedBy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a722cae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a722cae', __exports__)) {
    console.log('reload')
    api.reload('6a722cae', __exports__)
  }
  
  module.hot.accept("./TrustedBy.vue?vue&type=template&id=6a722cae&scoped=true", () => {
    console.log('re-render')
    api.rerender('6a722cae', render)
  })

}


export default __exports__